var exports = {
  "mJ": "x127c5a35--794d0f--input_title",
  "iA": "x127c5a35--794d0f--checkboxes",
  "vK": "x127c5a35--794d0f--banner",
  "ir": "x127c5a35--794d0f--footer_actions",
  "pv": "x127c5a35--794d0f--delete_button",
};

module.exports = exports;
